import { Box, Breadcrumbs, Typography, Stack, Paper, Chip, Button, Alert } from '@mui/material'
import { Computer, LogoutOutlined } from '@mui/icons-material'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getSessions, revokeSession } from '../api/authFlows'
import { errorMessage } from '../api/client'

/** FR-ADM-001i — sesiuni concurente vizibile, cu închidere individuală. */
export default function SessionsPage() {
  const qc = useQueryClient()
  const { data, isLoading } = useQuery({ queryKey: ['auth', 'sessions'], queryFn: getSessions })

  const mutation = useMutation({
    mutationFn: revokeSession,
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['auth', 'sessions'] }),
  })

  return (
    <Stack spacing={2}>
      <Breadcrumbs separator="/" sx={{ fontSize: 12.5 }}>
        <Typography variant="inherit" color="text.secondary">Administrare</Typography>
        <Typography variant="inherit" color="text.primary">Sesiuni active</Typography>
      </Breadcrumbs>

      <Typography variant="h2">Sesiuni active</Typography>
      <Typography variant="body2" color="text.secondary">
        Dispozitivele și browserele conectate la contul dvs. Puteți fi autentificat simultan
        pe mai multe dispozitive (de exemplu desktop și terminalul de la producție).
      </Typography>

      {mutation.isError && <Alert severity="error">{errorMessage(mutation.error)}</Alert>}

      <Stack spacing={1}>
        {!isLoading && data?.length === 0 && (
          <Typography variant="body2" color="text.secondary">Nicio sesiune activă.</Typography>
        )}
        {data?.map((s) => (
          <Paper key={s.id} variant="outlined" sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
            <Computer color="action" />
            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
              <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                <Typography variant="body2" noWrap sx={{ maxWidth: 480, fontWeight: 600 }}>
                  {s.userAgent ?? 'Dispozitiv necunoscut'}
                </Typography>
                {s.isCurrent && <Chip label="sesiunea curentă" size="small" color="primary" variant="outlined" />}
              </Stack>
              <Typography variant="caption" color="text.secondary">
                {s.ipAddress ?? '—'} · ultima activitate {new Date(s.lastUsedAt).toLocaleString('ro-RO')}
              </Typography>
            </Box>
            {!s.isCurrent && (
              <Button size="small" color="error" startIcon={<LogoutOutlined />}
                onClick={() => mutation.mutate(s.id)} disabled={mutation.isPending}>
                Închide
              </Button>
            )}
          </Paper>
        ))}
      </Stack>
    </Stack>
  )
}
